{
  "de": {
    "backofficeHeader": {
      "exit": "Backoffice verlassen"
    }
  }
}
